import api from '@/api.js'
import common from '@/common.js'
import Cookies from 'js-cookie'

import router, { routesList } from '@/router'

const state = {
    userInfo: {},
    token: '',
    app: null,
    isShow: false,
    sidebarShow: false,
    loading: {
        show: false,
        text: ''
    },
    aiLoading: false, //AI思考中。。。
    catalogueTree: [],
    catalogueList: [],
    bookList: [],
    drugInfoList: [],
    drugInfoListIndex: 0,
    isDark: false,
    djs: null,
    besideRoll: 0,
    menus: [],
    menuPageButtonList: [], //按钮权限
    version: "",
    exUserInfo: {},
    dicts: {}, //数据字典
}
const getters = {
    token: state => state.userInfo.newToken,
    // token: () => 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyVHlwZUlkIjoyLCJpcCI6IjE5Mi4xNjguMTAuMiIsImlzcyI6InVzZXIiLCJob3NwaXRhbE5hbWUiOiLpk4XlsbHljLvppoYiLCJ1c2VyTmFtZSI6IuWlveWMu-eUnyIsInVzZXJJZCI6IjU1IiwiaG9zcGl0YWxDb2RlIjoiMTIiLCJzb2NrZXRDbGllbnRJZCI6IjU1XzIzMDExODEwMDg1NjExMiIsImlzU2luZ2xlU2lnbiI6MCwiemhVc2VySWQiOiIxNSIsImxvZ2luTmFtZSI6Imhhb3NuIiwiZXhwIjoxNjc0MDYxNzM2LCJjZWxsUGhvbmUiOiIxODk1NTE0NTIwMSJ9.PRkNHN6SiEVxYXz8rHRhxQwkt0IUHoH0PzD75Pq8C-M',
    isLogin: state => state.userInfo.newToken,
    oldToken: state => state.userInfo.token,
    userInfo: state => state.userInfo,
    isShow: state => state.isShow,
    version: state => state.version,
    sidebarShow: state => state.sidebarShow,
    loading: state => state.loading,
    catalogueTree: state => state.catalogueTree,
    catalogueList: state => state.catalogueList,
    isDark: state => state.isDark,
    bookList: state => state.bookList,
    drugInfoList: state => state.drugInfoList,
    drugInfoListIndex: state => state.drugInfoListIndex,
    besideRoll: state => state.besideRoll,
    menus: state => state.menus,
    menuPageButtonList: state => state.menuPageButtonList,
    aiLoading: state => state.aiLoading,
    exUserInfo: state => state.exUserInfo,
    dicts: state => state.dicts,
}
const mutations = {
    setVersion(state, res) {
        state.version = res;
    },
    besideRoll(state) {
        state.besideRoll = Math.random();
    },
    drugInfoListIndex(state, res) {
        state.drugInfoListIndex = res;
    },
    drugInfoList(state, res) {
        state.drugInfoList = res;
    },
    setBookList(state, res) {
        state.bookList = res;
    },
    setIsDark(state, res) {
        clearInterval(state.djs);
        state.isDark = res;
        localStorage.setItem("isDark", res);
    },
    setCatalogueList(state, res) {
        state.catalogueList = res;
    },
    setCatalogueTree(state, res) {
        state.catalogueTree = res;
    },
    setAiLoading(state, res) {
        state.aiLoading = res;
    },
    showLoading(state, text) {
        state.loading.show = true;
        state.loading.text = text || '';
    },
    hideLoading(state) {
        state.loading.show = false;
        state.loading.text = '';
    },
    setSidebarShow(state, res) {
        state.sidebarShow = res;
    },
    // 账号绑定
    employeeLogin(state, res) {
        if (common.isError(res)) return;
        state.userInfo = res.result.data;

        // 设置登录失效时间
        if(!Cookies.get('userInfo')){
            let expiredTime = state.userInfo.expiredTime;
            let expires = new Date(new Date().getTime() + expiredTime);
            Cookies.set('userInfo', JSON.stringify(res), { expires })
        }
        // Cookies.set('isLogin', 'true', { expires, domain: ".cimaizhongyi.com" })
        this.dispatch('getUserRolePageList', { "sysCode": 9 })
        this.commit("startSocket");
        this.dispatch('getPersonalData')
    },
    logout(state) {
        window.location.replace('/#/home')
        state.userInfo = {}
        state.exUserInfo = {}
        Cookies.remove('userInfo');
        this.commit('closeSocket')
    },
    getUserRolePageList(state, res) {
        if (common.isError(res)) return;
        state.menus = res.result;

        // 设置按钮权限
        let arr = [];
        state.menus.forEach(i => {
            i.menuPageButtonList.forEach(j => {
                arr.push(i.menuId + ":" + j.buttonCode)
            })
            console.log(arr)
        })

        // 权限测试
        // arr = [
        //     "bookAndDrug:aichat",
        //     "bookAndDrug:aiimage",
        //     "bookAndDrug:voicetotext",
        // ];

        state.menuPageButtonList = arr;

        if (!state.menuPageButtonList.length) {
            let index = routesList.findIndex(i => i.name == 'chatGpt')
            routesList.splice(index, 1)
        }

        let item = state.menus.find(i => i.menuId == "bookAndDrug")
        if (item) {
            router.addRoutes(routesList)
        }
        // router.addRoutes(routesList)

        let fullPath = localStorage.getItem("fullPath2");
        if (fullPath) {
            state.app.$router.push(fullPath);
        } else {
            state.app.$router.push('/pageSearch');
        }

        setTimeout(() => {
            state.isShow = true;
        }, 500)
    },
    openApp(state, res) {
        let isDark = localStorage.getItem("isDark")
        state.isDark = isDark && isDark == 'true';
        if (!isDark) {
            state.isDark = common.isDark();
            state.djs = setInterval(() => {
                state.isDark = common.isDark();
            }, 60000);
        }

        state.app = res;
        let userInfo = Cookies.get('userInfo')
        if (userInfo) {
            this.commit('employeeLogin', JSON.parse(userInfo));
        } else {
            state.isShow = true;
        }

        // 设置数据字典
        let dicts = JSON.parse(sessionStorage.getItem('dicts'));
        if (dicts) this.commit('setDicts2', dicts)
    },
    getExUserInfo(state, res) {
        state.exUserInfo = res
    },
    setDicts(state, res) {
        let obj = common.clone(state.dicts);
        obj[res.key] = res.data;
        state.dicts = obj;
        sessionStorage.setItem('dicts', JSON.stringify(state.dicts));
    },
    setDicts2(state, res) {
        state.dicts = res;
    },
}
const actions = {
    //登录 
    tokenLogin({ commit }) {
        return api("tokenLogin", {
            sysCode: ""
          }).then(res => {
            commit('employeeLogin', res.result)
        });
    },
    //登录 
    employeeLogin({ commit }, data) {
        return api("employeeLogin", data).then(res => {
            commit('employeeLogin', res.result)
        });
    },
    //用户菜单权限
    getUserRolePageList({ commit }, data) {
        return api("getUserRolePageList", data).then(res => {
            commit('getUserRolePageList', res)
        });
    },
    //用户菜单权限
    getBookDetail({ commit, state }, data) {
        let cl = state.catalogueList;
        if (cl.length && cl[0].bookId == data.bookId) {
            return;
        }

        state.catalogueList = [];
        state.catalogueTree = [];

        commit("showLoading");
        return api("getBookDetail", data).then(res => {
            let list = res.result;
            list.unshift({
                "level1": "0",
            })
            let d = common.catalogueFormatData(list, 1)
            let arr = common.catalogueToList(d.children, 0);
            commit("setCatalogueList", arr)
            commit("setCatalogueTree", d.children)
            commit("hideLoading");
        });
    },
    //获取用户信息
    getPersonalData() {
        api("getCsgUserInformation").then(res => {
            if (res.result) {
                this.commit('getExUserInfo', res.result)
            }
        })
    },
    getWideUseDict({
        state,
        commit,
        rootGetters
    }, key) {
        let dists = sessionStorage.getItem('dicts')
        let getStore = dists ? JSON.parse(dists) : '';
        if (getStore && getStore[key]) {
            return Promise.resolve(getStore[key]);
        } else {
            let obj = {
                "targetUse": key
            };
            return api('getWideUseDict', obj).then(res => {
                let list = res.result.map(i => {
                    i.value = i.mainKey;
                    i.label = i.string1;
                    return i;
                })
                commit('setDicts', {
                    data: list,
                    key
                })
            });
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}